import React, { createContext, FC, useState } from 'react'

import { DocasContextValue } from './ContextType'
import { DocasContextInitialValues } from './InitialValues'

interface IProps {
  docasContext: DocasContextValue
  setDocasContext: (value: DocasContextValue) => void
}

export const DocasContext = createContext<IProps>({
  docasContext: DocasContextInitialValues,
  setDocasContext: (value: DocasContextValue) => void 0,
})

export const DocasProvider: FC = ({ children }) => {
  const [state, setState] = useState<DocasContextValue>(
    DocasContextInitialValues,
  )

  const updateContext = (value: DocasContextValue) => {
    setState(value)
  }

  return (
    <DocasContext.Provider
      value={{
        docasContext: state,
        setDocasContext: (value: DocasContextValue) => updateContext(value),
      }}
    >
      {children}
    </DocasContext.Provider>
  )
}
